import React from 'react'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom';
//-----------------------------------------------
import Headline from '../../Headlines/PageHeadline'
//import Paper from '@material-ui/core/Paper'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import Badge from '@material-ui/core/Badge';
//import AddAlertIcon from '@material-ui/icons/AddAlert'


import {homeGridSettings} from '../../../js/settings/grid'


const styles = theme  => {
    return ({
    card: {
        cursor: 'pointer',
        marginBottom: theme.spacing.unit,
        height: '8em',
        width: '14em',
        //backgroundColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
        //border: '2px solid' + theme.palette.primary.main,
        borderRadius: 0,
        //border: 'none',
          //textAlign: 'center',
          //borderBottom: '1px solid '+ theme.palette.primary.light
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
           boxShadow: '2px 2px 2px 2px white',
           
          }
      },
        homeContent: {
            position: 'relative',
            //backgroundColor: 'gray',
            width: '100%',
            height: '100%',
          
        },
        homeHeader: {
            position: 'absolute',
            top: '18px',
            right: '24px',           
        },
        homeFooter: {
            position: 'absolute',
            bottom: theme.spacing.unit,
            left: theme.spacing.unit,
            //padding: theme.spacing.unit,
        },

        lable: {
            //fontSize: '0.7422em',
            letterSpacing: '0.1555em',
            //color: theme.palette.primary.main,
            color: 'white'
        },
        badgeLable: {
            fontSize: '0.8em',
            textTransporm: 'uppercase',
            marginRight: '15px',
            color: 'white'
        },

        badge: {
            //margin: '10px'
            
                
                
        
            },
        


})}

const Home = (props) => {
    const { classes, navItems, history } = props
    const tooltipMessage = 'Mit einem Klick bist du dort'

    return (
        <div className={classes.root}>
        <Headline headline='Home' subtext={null} />
        <Grid container {...homeGridSettings.container}>
            {
                navItems.map((navItem, key) => {
                return (<Grid key={key} item {...homeGridSettings.breakPoints}>
                    <Tooltip title={tooltipMessage} enterDelay={500} leaveDelay={200}>
                        <Card 
                            className={classes.card}
                            onClick={()=>history.push(navItem.route)}
                        >
                            <div className={classes.homeContent}>
                                
                                <div className={classes.homeHeader}>
                                {navItem.counter
                                            ? <Badge 
                                                color='secondary'
                                                children={<span className={classes.badgeLable}></span>}
                                                badgeContent={navItem.counter}
                                                className={classes.badge} 

                                                />
                                            : null
                                }
                                </div>
                                <div className={classes.homeFooter}>
                                    <Typography className={classes.lable} children={navItem.lable} variant='subheading' />
                                </div>

                                
                            </div>
                        </Card>
                    </Tooltip>
                </Grid>
                )})
            }
        </Grid>
        </div>
    )
    }


    export default compose(
        withRouter,
        withStyles(styles)
    )(Home)


// WEBPACK FOOTER //
// ./src/Container/Content/Home/Home.js